import React from "react";

const ResponseCard = ({ response, showRefresh = true }) => {
    const refreshPage = (e) => {
        e.preventDefault();
        window.location.reload(true);
    };

    return (
        <div data-testid={'responseCard'}>
            <div className={"headerText"}>{response.title}</div>
            <span className={"detailsText vertMargin subTitleText"}>{response.message}</span>
            <br/><br/>
            {
                showRefresh && (
                    <button type={"button"}
                            data-testid={'refreshBtn'}
                            className={"button-pay"}
                            onClick={refreshPage}>
                        {i18n.common.refresh}
                    </button>
                )
            }
        </div>
    );
}

export default ResponseCard;